<template>
    <v-container fluid fill-height>        
        <v-layout col justify-center align-center class="mb-5">
            <v-flex xs4>
                <v-card class="mb-5">
                    <v-card-title class="subheading font-weight-regular justify-space-between">                                              
                        <v-container fluid>
                            <v-layout row wrap align-center justify-center class="text-xs-center">
                                <v-flex d-flex xs12 >
                                    <h3 class="headline">Anmeldung</h3>
                                </v-flex>
                                <v-flex d-flex xs12>
                                    <h4 class="subheading pt-3">Anmeldung für den Nöcker-Behnk Archiver</h4>
                                </v-flex>                            
                            </v-layout>
                        </v-container>
                    </v-card-title>                                            

                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <v-card-text>
                                <v-flex xs12 class="py-0 mb-0">           
                                    <span class="red--text py-0 my-0" 
                                          v-if="errors.collect('email','login')">
                                        {{ errors.first('email', 'login') }}
                                    </span>            
                                </v-flex>
                                <v-text-field
                                    label="Email"
                                    v-model="user.email"
                                    data-vv-scope="login"
                                    data-vv-name="email"
                                    light
                                    color="#000"
                                    v-validate.immediate="rules.email"  
                                ></v-text-field>
                                <span class="caption grey--text text--darken-1">
                                    Bitte die E-Mail für Ihren Account eingeben!
                                 </span>
                            </v-card-text>
                        </v-window-item>

                        <v-window-item :value="2">
                            <v-card-text>
                                <v-flex xs12 class="py-0 mb-0">           
                                    <span class="red--text py-0 my-0" 
                                          v-if="errors.collect('password','login')">
                                        {{ errors.first('password', 'login') }}
                                    </span>            
                                </v-flex>                                
                                <v-text-field
                                    label="Password"
                                    type="password"
                                    v-model="user.password"
                                    data-vv-scope="login"
                                    data-vv-name="password"
                                    v-validate.immediate="rules.password"  
                                ></v-text-field>          
                                <span class="caption grey--text text--darken-1">
                                    Bitte das Passwort für Ihren Account eingeben!                                    
                                </span>
                            </v-card-text>
                        </v-window-item>
                        <v-window-item :value="3">
                            <v-card-text>
                                                           
                                Anmeldung erfolgt!
                            </v-card-text>
                        </v-window-item>
                    </v-window>
                   
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn
                            :disabled="step === 1"
                            flat
                            @click="loginsteps(-1)"
                        >
                            Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :disabled="step === 3 || this.errors.has(currentField,'login')"
                            color="grey darken-4"
                            dark
                            depressed
                            @click="loginsteps(1)"
                        >
                            {{currentTitle}}
                        </v-btn>
                      </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
export default {
    inject: ['$validator'],
    data: () => ({
        step: 1,
        user:{
            email:'',
            password:''
        },
        rules:{
            email:'required|email',
            password:'required'
        },
        
    }),

    computed: {
        currentTitle () {
            switch (this.step) {
                case 1: return 'Next'
                case 2: return 'Login'                
            }
        },
        currentField() {
            switch (this.step) {
                case 1: return 'email'
                case 2: return 'password'                
            }
        }
        
    },
    methods:{
        loginsteps(val) {
            this.step += val
            if(this.step ==3){
                this.initMessage()
                if(this.errors.any('login')) {
                    this.setMessage('422',this.errors.all('login'))                            
                    return
                }    
                
                this.$store.dispatch('auth/loginUser', this.user)
                    .then(response=>{   
                        this.$store.dispatch('auth/setAuthenticatedUser')
                        .then(response => {
                            this.setMessage(response.status,"Erfolg! Sie sind eingeloggt!")
                            this.$router.push({ 
                                name: 'home'
                            })
                        }).catch(error=>{
                            this.setMessage(error.response.status,error.response.data.message)
                        })
                        
                    }).catch(error => {                    
                        this.setMessage(error.response.status,error.response.data.message)                    
                        
                }) 
                return
            }
        }                    
    }
    
    
}
</script>